import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import logo from "../../../assets/logo.png";
import logout from "../../../service/logout";
import Logout from "../../LogoutModal/Logout";
import LogoutModal from "../../LogoutModal/LogoutModal";

const SidebarRouting = ({ menuItems }) => {
  const [showModal, setShowModal] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // Recursive function to find active key
  const findActiveKey = (items, pathname) => {
    for (const item of items) {
      if (item.path && pathname.startsWith(item.path)) {
        return item.key;
      }
      if (item.children) {
        const childActiveKey = findActiveKey(item.children, pathname);
        if (childActiveKey) {
          return childActiveKey;
        }
      }
    }
    return null;
  };

  // Get active path from location
  const activeKey = findActiveKey(menuItems, location.pathname);

  // Recursive function to process menu items with multiple levels
  const processMenuItems = (items) => {
    return items.map((item) => {
      const menuItem = {
        key: item.key,
        icon: item.icon,
        label: <span className={collapsed ? "hidden" : ""}>{item.label}</span>,
        onClick: item.path ? () => navigate(item.path) : undefined,
      };

      // Handle children recursively
      if (item.children) {
        menuItem.children = processMenuItems(item.children);
      }

      return menuItem;
    });
  };

  return (
    <div
      className={`flex flex-col h-screen transition-all duration-300 ${
        collapsed ? "w-30" : "w-64"
      } `}
    >
      <Menu
        mode="inline"
        theme="light"
        selectable={false}
        items={[
          {
            key: "toggle",
            icon: collapsed ? (
              <MenuUnfoldOutlined className="" />
            ) : (
              <MenuFoldOutlined />
            ),
            onClick: toggleCollapsed,
            label: (
              <img
                src={logo}
                alt="Logo"
                className={collapsed ? "hidden" : "w-24 ml-6"}
              />
            ),
          },
        ]}
        className="border-b py-4"
      />

      <Menu
        mode="inline"
        theme="light"
        selectedKeys={activeKey ? [activeKey] : []}
        items={processMenuItems(menuItems)}
        className="flex-1 overflow-y-auto thin-scrollbar pt-4"
      />

      <Menu
        mode="vertical"
        theme="light"
        items={[
          {
            key: "logout",
            icon: <LogoutOutlined />,
            label: (
              <span className={collapsed ? "hidden" : "ml-2"}>Logout</span>
            ),
            onClick: () => setShowModal(true),
          },
        ]}
        className="border-t"
      />

      <LogoutModal
        showModal={showModal}
        closeModal={() => setShowModal(false)}
        handleLogout={logout}
      />
    </div>
  );
};

export default SidebarRouting;
